import { Component, inject } from '@angular/core';
import { TranslatePipe } from '../../../core/shared/translation/translate.pipe';
import { UserVipService } from '../../../core/services/user/user-vip.service';
import { VipLevelLabelComponent } from '../vip-level-label/vip-level-label.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-vip-earn',
  imports: [TranslatePipe, VipLevelLabelComponent, RouterLink],
  templateUrl: './vip-earn.component.html',
  styleUrl: './vip-earn.component.scss',
})
export class VipEarnComponent {
  public vip$ = inject(UserVipService);
}
